export function uint8ArrayToHex(r){for(var t="",n=0;n<r.length;++n){var e=r[n].toString(16);1==e.length&&(e="0"+e),t+=e}return t}